// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AdminCreateAgentData, AdminCreateAgentErrors, AdminCreateAgentResponses, AdminCreateArtifactData, AdminCreateArtifactErrors, AdminCreateArtifactResponses, AdminCreateTagData, AdminCreateTagErrors, AdminCreateTagResponses, AdminCreateUserData, AdminCreateUserErrors, AdminCreateUserResponses, AdminDeleteAgentData, AdminDeleteAgentErrors, AdminDeleteAgentResponses, AdminDeleteAgentsData, AdminDeleteAgentsErrors, AdminDeleteAgentsResponses, AdminDeleteArtifactData, AdminDeleteArtifactErrors, AdminDeleteArtifactResponses, AdminDeleteArtifactsData, AdminDeleteArtifactsErrors, AdminDeleteArtifactsResponses, AdminDeleteDocumentData, AdminDeleteDocumentErrors, AdminDeleteDocumentResponses, AdminDeleteTagData, AdminDeleteTagErrors, AdminDeleteTagResponses, AdminDeleteTagsData, AdminDeleteTagsErrors, AdminDeleteTagsResponses, AdminGetAgentData, AdminGetAgentErrors, AdminGetAgentResponses, AdminGetAgentsData, AdminGetAgentsErrors, AdminGetAgentsResponses, AdminGetArtifactData, AdminGetArtifactErrors, AdminGetArtifactResponses, AdminGetArtifactsData, AdminGetArtifactsErrors, AdminGetArtifactsResponses, AdminGetDocumentData, AdminGetDocumentErrors, AdminGetDocumentResponses, AdminGetDocumentsData, AdminGetDocumentsErrors, AdminGetDocumentsResponses, AdminGetTagData, AdminGetTagErrors, AdminGetTagResponses, AdminGetTagsData, AdminGetTagsErrors, AdminGetTagsResponses, AdminUpdateAgentData, AdminUpdateAgentErrors, AdminUpdateAgentResponses, AdminUpdateArtifactData, AdminUpdateArtifactErrors, AdminUpdateArtifactResponses, AdminUpdateDocumentData, AdminUpdateDocumentErrors, AdminUpdateDocumentResponses, AdminUpdateTagData, AdminUpdateTagErrors, AdminUpdateTagResponses, AuthCallbackData, AuthCallbackErrors, AuthCallbackResponses, BillingStatusData, BillingStatusErrors, BillingStatusResponses, CalendarSyncStatusData, CalendarSyncStatusErrors, CalendarSyncStatusResponses, CastVote2Data, CastVote2Errors, CastVote2Responses, CastVoteData, CastVoteErrors, CastVoteResponses, ChatCreateArtifactData, ChatCreateArtifactErrors, ChatCreateArtifactResponses, ChatCreateEventData, ChatCreateEventErrors, ChatCreateEventResponses, ChatCreateTagData, ChatCreateTagErrors, ChatCreateTagResponses, ChatDeleteObjectsData, ChatDeleteObjectsErrors, ChatDeleteObjectsResponses, ChatUpdateArtifactData, ChatUpdateArtifactErrors, ChatUpdateArtifactResponses, ChatUpdateEventData, ChatUpdateEventErrors, ChatUpdateEventResponses, ChatUpdateTagData, ChatUpdateTagErrors, ChatUpdateTagResponses, ChatUploadDocumentData, ChatUploadDocumentErrors, ChatUploadDocumentResponses, CheckInviteStatusData, CheckInviteStatusErrors, CheckInviteStatusResponses, CheckLlmProviderData, CheckLlmProviderErrors, CheckLlmProviderResponses, ClearTranscriptionData, ClearTranscriptionErrors, ClearTranscriptionResponses, ClearVotes2Data, ClearVotes2Errors, ClearVotes2Responses, ClearVotesData, ClearVotesErrors, ClearVotesResponses, ConnectGoogleCalendarData, ConnectGoogleCalendarErrors, ConnectGoogleCalendarResponses, CreateContextData, CreateContextErrors, CreateContextResponses, CreateEvent2Data, CreateEvent2Errors, CreateEvent2Responses, CreateEventData, CreateEventErrors, CreateEventResponses, CreateInviteData, CreateInviteErrors, CreateInviteResponses, CreateLocalCalendarForTagData, CreateLocalCalendarForTagErrors, CreateLocalCalendarForTagResponses, CreateModel2Data, CreateModel2Errors, CreateModel2Responses, CreateModelData, CreateModelErrors, CreateModelResponses, CreateOrganisationData, CreateOrganisationErrors, CreateOrganisationResponses, CreatePrompt2Data, CreatePrompt2Errors, CreatePrompt2Responses, CreatePromptData, CreatePromptErrors, CreatePromptResponses, CreateRecoveryLinkData, CreateRecoveryLinkErrors, CreateRecoveryLinkResponses, CreateTest2Data, CreateTest2Errors, CreateTest2Responses, CreateTestData, CreateTestErrors, CreateTestResponses, CreateUserPreferenceData, CreateUserPreferenceErrors, CreateUserPreferenceResponses, CreateUserSkillData, CreateUserSkillErrors, CreateUserSkillResponses, DeactivateOrganisationData, DeactivateOrganisationErrors, DeactivateOrganisationResponses, DeactivateOrganisationsData, DeactivateOrganisationsErrors, DeactivateOrganisationsResponses, DeactivateUserData, DeactivateUserErrors, DeactivateUserResponses, DeactivateUsersData, DeactivateUsersErrors, DeactivateUsersResponses, DeleteContextData, DeleteContextErrors, DeleteContextResponses, DeleteEvent2Data, DeleteEvent2Errors, DeleteEvent2Responses, DeleteEventData, DeleteEventErrors, DeleteEventResponses, DeleteI18nData, DeleteI18nErrors, DeleteI18nResponses, DeleteKvpData, DeleteKvpErrors, DeleteKvpResponses, DeleteModel2Data, DeleteModel2Errors, DeleteModel2Responses, DeleteModelData, DeleteModelErrors, DeleteModelResponses, DeletePrompt2Data, DeletePrompt2Errors, DeletePrompt2Responses, DeletePromptData, DeletePromptErrors, DeletePromptResponses, DeleteTest2Data, DeleteTest2Errors, DeleteTest2Responses, DeleteTestData, DeleteTestErrors, DeleteTestResponses, DeleteUserPreferenceData, DeleteUserPreferenceErrors, DeleteUserPreferenceResponses, DeleteUserPreferencesData, DeleteUserPreferencesErrors, DeleteUserPreferencesResponses, DeleteUserSkillData, DeleteUserSkillErrors, DeleteUserSkillResponses, DisableClientSyncData, DisableClientSyncErrors, DisableClientSyncResponses, DisconnectGoogleCalendarData, DisconnectGoogleCalendarErrors, DisconnectGoogleCalendarResponses, EmitUserActionData, EmitUserActionErrors, EmitUserActionResponses, EnsureWatchesData, EnsureWatchesErrors, EnsureWatchesResponses, ExportConversationSnapshotData, ExportConversationSnapshotErrors, ExportConversationSnapshotResponses, FillMissing2Data, FillMissing2Errors, FillMissing2Responses, FillMissingAll2Data, FillMissingAll2Errors, FillMissingAll2Responses, FillMissingAllData, FillMissingAllErrors, FillMissingAllResponses, FillMissingData, FillMissingErrors, FillMissingResponses, GenerateEventTranscriptionSummaryData, GenerateEventTranscriptionSummaryErrors, GenerateEventTranscriptionSummaryResponses, GetAgentsOverviewData, GetAgentsOverviewErrors, GetAgentsOverviewResponses, GetAtotTokenData, GetAtotTokenResponses, GetAvalibleAgentsInChildOrganisationData, GetAvalibleAgentsInChildOrganisationErrors, GetAvalibleAgentsInChildOrganisationResponses, GetChatData, GetChatErrors, GetChatResponses, GetChildOrganisationsData, GetChildOrganisationsErrors, GetChildOrganisationsResponses, GetClientData, GetClientErrors, GetClientPreferencesData, GetClientPreferencesErrors, GetClientPreferencesResponses, GetClientResponses, GetClientsData, GetClientsErrors, GetClientsResponses, GetClientViewChatData, GetClientViewChatErrors, GetClientViewChatResponses, GetContextData, GetContextErrors, GetContextResponses, GetConversationHistoryData, GetConversationHistoryErrors, GetConversationHistoryResponses, GetDocumentFileData, GetDocumentFileErrors, GetDocumentFileResponses, GetDraftObjectsData, GetDraftObjectsErrors, GetDraftObjectsResponses, GetEventData, GetEventErrors, GetEventResponses, GetEventsData, GetEventsErrors, GetEventsResponses, GetEventTranscriptionData, GetEventTranscriptionErrors, GetEventTranscriptionResponses, GetI18nAdminData, GetI18nAdminErrors, GetI18nAdminResponses, GetI18nData, GetI18nErrors, GetI18nLocalesData, GetI18nLocalesResponses, GetI18nResponses, GetKvpData, GetKvpErrors, GetKvpResponses, GetLatestChatsData, GetLatestChatsErrors, GetLatestChatsResponses, GetOrganisationData, GetOrganisationErrors, GetOrganisationResponses, GetOrganisationsData, GetOrganisationsErrors, GetOrganisationsResponses, GetOrganisationTreeData, GetOrganisationTreeErrors, GetOrganisationTreeResponses, GetPaymentInformationData, GetPaymentInformationErrors, GetPaymentInformationResponses, GetResults2Data, GetResults2Errors, GetResults2Responses, GetResultsData, GetResultsErrors, GetResultsResponses, GetTagEventsData, GetTagEventsErrors, GetTagEventsResponses, GetToolUseData, GetToolUseErrors, GetToolUseResponses, GetTranscriptionData, GetTranscriptionErrors, GetTranscriptionResponses, GetUpcomingEventsData, GetUpcomingEventsErrors, GetUpcomingEventsResponses, GetUserPreferencesData, GetUserPreferencesErrors, GetUserPreferencesResponses, GetUserSkillsData, GetUserSkillsErrors, GetUserSkillsResponses, GetWebPageData, GetWebPageErrors, GetWebPageResponses, GetWebPagesData, GetWebPagesResponses, GoogleCalendarCallbackData, GoogleCalendarCallbackErrors, GoogleCalendarCallbackResponses, GrantDemoAccessData, GrantDemoAccessErrors, GrantDemoAccessResponses, HandleGoogleCalendarWebhookData, HandleGoogleCalendarWebhookErrors, HandleGoogleCalendarWebhookResponses, InvoicePdfData, InvoicePdfErrors, InvoicePdfResponses, ListContextsData, ListContextsErrors, ListContextsResponses, ListEventsData, ListEventsErrors, ListEventsResponses, ListInvoicesData, ListInvoicesErrors, ListInvoicesResponses, ListJudges2Data, ListJudges2Errors, ListJudges2Responses, ListJudgesData, ListJudgesErrors, ListJudgesResponses, ListKvpKeysData, ListKvpKeysErrors, ListKvpKeysResponses, ListLlmModelAssignmentsData, ListLlmModelAssignmentsErrors, ListLlmModelAssignmentsResponses, ListLlmModelsData, ListLlmModelsErrors, ListLlmModelsResponses, ListLlmProvidersData, ListLlmProvidersErrors, ListLlmProvidersResponses, ListModels2Data, ListModels2Errors, ListModels2Responses, ListModelsData, ListModelsErrors, ListModelsResponses, ListOutputsData, ListOutputsErrors, ListOutputsResponses, ListPrompts2Data, ListPrompts2Errors, ListPrompts2Responses, ListPromptsData, ListPromptsErrors, ListPromptsResponses, ListSkillsData, ListSkillsErrors, ListSkillsResponses, ListTests2Data, ListTests2Errors, ListTests2Responses, ListTestsData, ListTestsErrors, ListTestsResponses, LoginForAccessTokenData, LoginForAccessTokenErrors, LoginForAccessTokenResponses, LoginOauthData, LoginOauthErrors, LoginOauthResponses, LogoutData, LogoutErrors, LogoutResponses, ModifyClientPreferencesData, ModifyClientPreferencesErrors, ModifyClientPreferencesResponses, MollieTestWebhookData, MollieTestWebhookErrors, MollieTestWebhookResponses, MollieWebhookData, MollieWebhookErrors, MollieWebhookResponses, NextPair2Data, NextPair2Errors, NextPair2Responses, NextPairData, NextPairErrors, NextPairResponses, PostFrontendErrorData, PostFrontendErrorErrors, PostFrontendErrorResponses, Progress2Data, Progress2Errors, Progress2Responses, ProgressData, ProgressErrors, ProgressResponses, ReadUsersMeData, ReadUsersMeErrors, ReadUsersMeResponses, RegisterWithInviteData, RegisterWithInviteErrors, RegisterWithInviteResponses, ResetChatData, ResetChatErrors, ResetChatResponses, RevokeDemoAccessData, RevokeDemoAccessErrors, RevokeDemoAccessResponses, RunTest2Data, RunTest2Errors, RunTest2Responses, RunTestData, RunTestErrors, RunTestResponses, SandboxCreateData, SandboxCreateErrors, SandboxCreateResponses, SandboxDeleteData, SandboxDeleteErrors, SandboxDeleteResponses, SandboxExpireGraceData, SandboxExpireGraceErrors, SandboxExpireGraceResponses, SandboxFlagsData, SandboxFlagsErrors, SandboxFlagsResponses, SandboxInjectUsageData, SandboxInjectUsageErrors, SandboxInjectUsageResponses, SandboxListData, SandboxListErrors, SandboxListResponses, SandboxRefundData, SandboxRefundErrors, SandboxRefundResponses, SandboxResetData, SandboxResetErrors, SandboxResetResponses, SandboxRevokeMandateData, SandboxRevokeMandateErrors, SandboxRevokeMandateResponses, SandboxRunJobData, SandboxRunJobErrors, SandboxRunJobResponses, SandboxStateData, SandboxStateErrors, SandboxStateResponses, SandboxWebhookData, SandboxWebhookErrors, SandboxWebhookResponses, ServeSpaData, ServeSpaErrors, ServeSpaResponses, ServiceCalendarWithGoogleData, ServiceCalendarWithGoogleErrors, ServiceCalendarWithGoogleResponses, SetActive2Data, SetActive2Errors, SetActive2Responses, SetActiveAgentData, SetActiveAgentErrors, SetActiveAgentResponses, SetActiveData, SetActiveErrors, SetActiveOrganisationData, SetActiveOrganisationErrors, SetActiveOrganisationResponses, SetActiveResponses, SetI18nData, SetI18nErrors, SetI18nResponses, SetKvpData, SetKvpErrors, SetKvpResponses, SetLlmModelAssignmentData, SetLlmModelAssignmentErrors, SetLlmModelAssignmentResponses, SetLocaleData, SetLocaleErrors, SetLocaleResponses, SetupPaymentMethodData, SetupPaymentMethodErrors, SetupPaymentMethodResponses, SetUsageCeilingData, SetUsageCeilingErrors, SetUsageCeilingResponses, SubmitContactData, SubmitContactErrors, SubmitContactResponses, SyncAllClientsData, SyncAllClientsErrors, SyncAllClientsResponses, SyncCalendarData, SyncCalendarErrors, SyncCalendarResponses, SyncCheckoutData, SyncCheckoutErrors, SyncCheckoutResponses, SyncLlmModelsData, SyncLlmModelsErrors, SyncLlmModelsResponses, UpdateEventData, UpdateEventErrors, UpdateEventResponses, UpdateLlmModelData, UpdateLlmModelErrors, UpdateLlmModelResponses, UpdateOrganisationData, UpdateOrganisationErrors, UpdateOrganisationResponses, UpdatePaymentInformationData, UpdatePaymentInformationErrors, UpdatePaymentInformationResponses, UpdatePrompt2Data, UpdatePrompt2Errors, UpdatePrompt2Responses, UpdatePromptData, UpdatePromptErrors, UpdatePromptResponses, UpdateSpeakerProfileData, UpdateSpeakerProfileErrors, UpdateSpeakerProfileResponses, UpdateTagSpeakerProfileData, UpdateTagSpeakerProfileErrors, UpdateTagSpeakerProfileResponses, UpdateTest2Data, UpdateTest2Errors, UpdateTest2Responses, UpdateTestData, UpdateTestErrors, UpdateTestResponses, UpdateUserData, UpdateUserErrors, UpdateUserPreferenceData, UpdateUserPreferenceErrors, UpdateUserPreferenceResponses, UpdateUserResponses, UpdateUserSkillData, UpdateUserSkillErrors, UpdateUserSkillResponses, UsageCostByUserData, UsageCostByUserErrors, UsageCostByUserResponses, UsageMeterData, UsageMeterErrors, UsageMeterResponses, UsageNetByUserData, UsageNetByUserErrors, UsageNetByUserResponses, UsageRevenueByUserData, UsageRevenueByUserErrors, UsageRevenueByUserResponses, WatchCalendarEndpointData, WatchCalendarEndpointErrors, WatchCalendarEndpointResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Connect Google Calendar
 *
 * Start calendar-only incremental Google consent for the signed-in user.
 */
export const connectGoogleCalendar = <ThrowOnError extends boolean = false>(options?: Options<ConnectGoogleCalendarData, ThrowOnError>) => (options?.client ?? client).get<ConnectGoogleCalendarResponses, ConnectGoogleCalendarErrors, ThrowOnError>({ url: '/api/auth/calendar/google/connect', ...options });

/**
 * Google Calendar Callback
 *
 * Store calendar credentials for the current user; never creates a user.
 */
export const googleCalendarCallback = <ThrowOnError extends boolean = false>(options?: Options<GoogleCalendarCallbackData, ThrowOnError>) => (options?.client ?? client).get<GoogleCalendarCallbackResponses, GoogleCalendarCallbackErrors, ThrowOnError>({ url: '/api/auth/calendar/google/callback', ...options });

/**
 * Disconnect Google Calendar
 *
 * Detach this user's Google watches/links without deleting remote calendars.
 */
export const disconnectGoogleCalendar = <ThrowOnError extends boolean = false>(options?: Options<DisconnectGoogleCalendarData, ThrowOnError>) => (options?.client ?? client).post<DisconnectGoogleCalendarResponses, DisconnectGoogleCalendarErrors, ThrowOnError>({ url: '/api/auth/calendar/google/disconnect', ...options });

/**
 * Login Oauth
 */
export const loginOauth = <ThrowOnError extends boolean = false>(options: Options<LoginOauthData, ThrowOnError>) => (options.client ?? client).get<LoginOauthResponses, LoginOauthErrors, ThrowOnError>({ url: '/api/auth/login/{provider}', ...options });

/**
 * Auth Callback
 */
export const authCallback = <ThrowOnError extends boolean = false>(options: Options<AuthCallbackData, ThrowOnError>) => (options.client ?? client).get<AuthCallbackResponses, AuthCallbackErrors, ThrowOnError>({ url: '/api/auth/{provider}/callback', ...options });

/**
 * Login For Access Token
 *
 * OAuth2 compatible token login, set cookies for future requests
 */
export const loginForAccessToken = <ThrowOnError extends boolean = false>(options: Options<LoginForAccessTokenData, ThrowOnError>) => (options.client ?? client).post<LoginForAccessTokenResponses, LoginForAccessTokenErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/api/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Logout
 *
 * Logout a user by invalidating their tokens and clearing cookies
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>) => (options?.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({ url: '/api/auth/logout', ...options });

/**
 * Register With Invite
 */
export const registerWithInvite = <ThrowOnError extends boolean = false>(options: Options<RegisterWithInviteData, ThrowOnError>) => (options.client ?? client).post<RegisterWithInviteResponses, RegisterWithInviteErrors, ThrowOnError>({
    url: '/api/auth/register-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Invite Status
 */
export const checkInviteStatus = <ThrowOnError extends boolean = false>(options: Options<CheckInviteStatusData, ThrowOnError>) => (options.client ?? client).get<CheckInviteStatusResponses, CheckInviteStatusErrors, ThrowOnError>({ url: '/api/auth/invites/{token}', ...options });

/**
 * Post Frontend Error
 */
export const postFrontendError = <ThrowOnError extends boolean = false>(options: Options<PostFrontendErrorData, ThrowOnError>) => (options.client ?? client).post<PostFrontendErrorResponses, PostFrontendErrorErrors, ThrowOnError>({
    url: '/api/misc/post-frontend-error',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Users Me
 *
 * Get details of the currently logged in user
 */
export const readUsersMe = <ThrowOnError extends boolean = false>(options?: Options<ReadUsersMeData, ThrowOnError>) => (options?.client ?? client).get<ReadUsersMeResponses, ReadUsersMeErrors, ThrowOnError>({ url: '/api/users/me', ...options });

/**
 * Set Locale
 */
export const setLocale = <ThrowOnError extends boolean = false>(options: Options<SetLocaleData, ThrowOnError>) => (options.client ?? client).post<SetLocaleResponses, SetLocaleErrors, ThrowOnError>({
    url: '/api/users/set-locale',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Create User
 *
 * Admin create client user through the dashboard.
 * Password is auto generated.
 * Only authenticated admin users can access this endpoint.
 */
export const adminCreateUser = <ThrowOnError extends boolean = false>(options: Options<AdminCreateUserData, ThrowOnError>) => (options.client ?? client).post<AdminCreateUserResponses, AdminCreateUserErrors, ThrowOnError>({
    url: '/api/users/create-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Invite
 *
 * Create an invite link for a new user.
 */
export const createInvite = <ThrowOnError extends boolean = false>(options: Options<CreateInviteData, ThrowOnError>) => (options.client ?? client).post<CreateInviteResponses, CreateInviteErrors, ThrowOnError>({
    url: '/api/users/create-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Recovery Link
 *
 * Generate an invite link for an existing user.
 */
export const createRecoveryLink = <ThrowOnError extends boolean = false>(options: Options<CreateRecoveryLinkData, ThrowOnError>) => (options.client ?? client).post<CreateRecoveryLinkResponses, CreateRecoveryLinkErrors, ThrowOnError>({
    url: '/api/users/create-recovery-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update User
 */
export const updateUser = <ThrowOnError extends boolean = false>(options: Options<UpdateUserData, ThrowOnError>) => (options.client ?? client).post<UpdateUserResponses, UpdateUserErrors, ThrowOnError>({
    url: '/api/users/update-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Clients
 */
export const getClients = <ThrowOnError extends boolean = false>(options: Options<GetClientsData, ThrowOnError>) => (options.client ?? client).post<GetClientsResponses, GetClientsErrors, ThrowOnError>({
    url: '/api/users/get-clients',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Client
 */
export const getClient = <ThrowOnError extends boolean = false>(options: Options<GetClientData, ThrowOnError>) => (options.client ?? client).post<GetClientResponses, GetClientErrors, ThrowOnError>({
    url: '/api/users/get-client',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Client Preferences
 */
export const getClientPreferences = <ThrowOnError extends boolean = false>(options: Options<GetClientPreferencesData, ThrowOnError>) => (options.client ?? client).post<GetClientPreferencesResponses, GetClientPreferencesErrors, ThrowOnError>({
    url: '/api/usersget-client-preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Modify Client Preferences
 */
export const modifyClientPreferences = <ThrowOnError extends boolean = false>(options: Options<ModifyClientPreferencesData, ThrowOnError>) => (options.client ?? client).post<ModifyClientPreferencesResponses, ModifyClientPreferencesErrors, ThrowOnError>({
    url: '/api/usersmodify-client-preference',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate User
 */
export const deactivateUser = <ThrowOnError extends boolean = false>(options: Options<DeactivateUserData, ThrowOnError>) => (options.client ?? client).post<DeactivateUserResponses, DeactivateUserErrors, ThrowOnError>({
    url: '/api/usersdeactivate-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate Users
 */
export const deactivateUsers = <ThrowOnError extends boolean = false>(options: Options<DeactivateUsersData, ThrowOnError>) => (options.client ?? client).post<DeactivateUsersResponses, DeactivateUsersErrors, ThrowOnError>({
    url: '/api/usersdeactivate-users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Speaker Profile
 */
export const updateSpeakerProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateSpeakerProfileData, ThrowOnError>) => (options.client ?? client).post<UpdateSpeakerProfileResponses, UpdateSpeakerProfileErrors, ThrowOnError>({
    url: '/api/users/update-speaker-profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Preferences
 */
export const getUserPreferences = <ThrowOnError extends boolean = false>(options?: Options<GetUserPreferencesData, ThrowOnError>) => (options?.client ?? client).get<GetUserPreferencesResponses, GetUserPreferencesErrors, ThrowOnError>({ url: '/api/users/get-user-preferences', ...options });

/**
 * Create User Preference
 */
export const createUserPreference = <ThrowOnError extends boolean = false>(options: Options<CreateUserPreferenceData, ThrowOnError>) => (options.client ?? client).post<CreateUserPreferenceResponses, CreateUserPreferenceErrors, ThrowOnError>({
    url: '/api/users/create-user-preference',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update User Preference
 */
export const updateUserPreference = <ThrowOnError extends boolean = false>(options: Options<UpdateUserPreferenceData, ThrowOnError>) => (options.client ?? client).post<UpdateUserPreferenceResponses, UpdateUserPreferenceErrors, ThrowOnError>({
    url: '/api/users/update-user-preference',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete User Preference
 */
export const deleteUserPreference = <ThrowOnError extends boolean = false>(options: Options<DeleteUserPreferenceData, ThrowOnError>) => (options.client ?? client).post<DeleteUserPreferenceResponses, DeleteUserPreferenceErrors, ThrowOnError>({
    url: '/api/users/delete-user-preference',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete User Preferences
 */
export const deleteUserPreferences = <ThrowOnError extends boolean = false>(options: Options<DeleteUserPreferencesData, ThrowOnError>) => (options.client ?? client).post<DeleteUserPreferencesResponses, DeleteUserPreferencesErrors, ThrowOnError>({
    url: '/api/users/delete-user-preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Skills
 *
 * The user's own skills, and the system skill keys a user skill can override.
 */
export const getUserSkills = <ThrowOnError extends boolean = false>(options?: Options<GetUserSkillsData, ThrowOnError>) => (options?.client ?? client).get<GetUserSkillsResponses, GetUserSkillsErrors, ThrowOnError>({ url: '/api/users/get-user-skills', ...options });

/**
 * Create User Skill
 */
export const createUserSkill = <ThrowOnError extends boolean = false>(options: Options<CreateUserSkillData, ThrowOnError>) => (options.client ?? client).post<CreateUserSkillResponses, CreateUserSkillErrors, ThrowOnError>({
    url: '/api/users/create-user-skill',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update User Skill
 */
export const updateUserSkill = <ThrowOnError extends boolean = false>(options: Options<UpdateUserSkillData, ThrowOnError>) => (options.client ?? client).post<UpdateUserSkillResponses, UpdateUserSkillErrors, ThrowOnError>({
    url: '/api/users/update-user-skill',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete User Skill
 */
export const deleteUserSkill = <ThrowOnError extends boolean = false>(options: Options<DeleteUserSkillData, ThrowOnError>) => (options.client ?? client).post<DeleteUserSkillResponses, DeleteUserSkillErrors, ThrowOnError>({
    url: '/api/users/delete-user-skill',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Create Artifact
 *
 * Admin create artifact through the dashboard.
 * Only authenticated admin users can access this endpoint.
 */
export const adminCreateArtifact = <ThrowOnError extends boolean = false>(options: Options<AdminCreateArtifactData, ThrowOnError>) => (options.client ?? client).post<AdminCreateArtifactResponses, AdminCreateArtifactErrors, ThrowOnError>({
    url: '/api/artifacts/create-artifact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Update Artifact
 *
 * Admin update artifact through the dashboard.
 * Only authenticated admin users can access this endpoint.
 */
export const adminUpdateArtifact = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateArtifactData, ThrowOnError>) => (options.client ?? client).post<AdminUpdateArtifactResponses, AdminUpdateArtifactErrors, ThrowOnError>({
    url: '/api/artifacts/update-artifact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Get Artifact
 */
export const adminGetArtifact = <ThrowOnError extends boolean = false>(options: Options<AdminGetArtifactData, ThrowOnError>) => (options.client ?? client).post<AdminGetArtifactResponses, AdminGetArtifactErrors, ThrowOnError>({
    url: '/api/artifacts/get-artifact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Delete Artifact
 *
 * Admin delete artifact by artifact id
 * Only authenticated admin users can access this endpoint.
 */
export const adminDeleteArtifact = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteArtifactData, ThrowOnError>) => (options.client ?? client).post<AdminDeleteArtifactResponses, AdminDeleteArtifactErrors, ThrowOnError>({
    url: '/api/artifacts/delete-artifact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Delete Artifacts
 *
 * Admin delete multiple artifacts by artifact ids
 * Only authenticated admin users can access this endpoint.
 */
export const adminDeleteArtifacts = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteArtifactsData, ThrowOnError>) => (options.client ?? client).post<AdminDeleteArtifactsResponses, AdminDeleteArtifactsErrors, ThrowOnError>({
    url: '/api/artifacts/delete-artifacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Get Artifacts
 *
 * Admin get artifacts through the dashboard.
 * Only authenticated admin users can access this endpoint.
 */
export const adminGetArtifacts = <ThrowOnError extends boolean = false>(options: Options<AdminGetArtifactsData, ThrowOnError>) => (options.client ?? client).post<AdminGetArtifactsResponses, AdminGetArtifactsErrors, ThrowOnError>({
    url: '/api/artifacts/get-artifacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Get Document
 */
export const adminGetDocument = <ThrowOnError extends boolean = false>(options: Options<AdminGetDocumentData, ThrowOnError>) => (options.client ?? client).post<AdminGetDocumentResponses, AdminGetDocumentErrors, ThrowOnError>({
    url: '/api/documents/get-document',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Get Documents
 */
export const adminGetDocuments = <ThrowOnError extends boolean = false>(options: Options<AdminGetDocumentsData, ThrowOnError>) => (options.client ?? client).post<AdminGetDocumentsResponses, AdminGetDocumentsErrors, ThrowOnError>({
    url: '/api/documents/get-documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Update Document
 */
export const adminUpdateDocument = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateDocumentData, ThrowOnError>) => (options.client ?? client).post<AdminUpdateDocumentResponses, AdminUpdateDocumentErrors, ThrowOnError>({
    url: '/api/documents/update-document',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Delete Document
 */
export const adminDeleteDocument = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteDocumentData, ThrowOnError>) => (options.client ?? client).post<AdminDeleteDocumentResponses, AdminDeleteDocumentErrors, ThrowOnError>({
    url: '/api/documents/delete-document',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Document File
 *
 * Return original file bytes. The only route that reads raw_data.
 */
export const getDocumentFile = <ThrowOnError extends boolean = false>(options: Options<GetDocumentFileData, ThrowOnError>) => (options.client ?? client).get<GetDocumentFileResponses, GetDocumentFileErrors, ThrowOnError>({ url: '/api/documents/{document_id}/file', ...options });

/**
 * Chat Update Artifact
 *
 * Update an artifact from tool message
 */
export const chatUpdateArtifact = <ThrowOnError extends boolean = false>(options: Options<ChatUpdateArtifactData, ThrowOnError>) => (options.client ?? client).post<ChatUpdateArtifactResponses, ChatUpdateArtifactErrors, ThrowOnError>({
    url: '/api/chatchat-update-artifact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chat Create Artifact
 *
 * Creates a draft artifact in the database, and appends a user_action message to the conversation.
 * Optional content/variable_name fill the note instead of leaving it empty.
 */
export const chatCreateArtifact = <ThrowOnError extends boolean = false>(options: Options<ChatCreateArtifactData, ThrowOnError>) => (options.client ?? client).post<ChatCreateArtifactResponses, ChatCreateArtifactErrors, ThrowOnError>({
    url: '/api/chatchat-create-artifact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chat Upload Document
 *
 * Create a document from an upload and append a user_action create message.
 *
 * A document is owned by exactly one tag, so the chat scope must name exactly
 * one. Summarisation is kicked off in the background; document/read waits on the
 * lock if the agent gets there first.
 */
export const chatUploadDocument = <ThrowOnError extends boolean = false>(options: Options<ChatUploadDocumentData, ThrowOnError>) => (options.client ?? client).post<ChatUploadDocumentResponses, ChatUploadDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/chatchat-upload-document',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Chat Update Tag
 *
 * Update a tag from tool message
 */
export const chatUpdateTag = <ThrowOnError extends boolean = false>(options: Options<ChatUpdateTagData, ThrowOnError>) => (options.client ?? client).post<ChatUpdateTagResponses, ChatUpdateTagErrors, ThrowOnError>({
    url: '/api/chatchat-update-tag',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chat Create Tag
 *
 * Creates an empty draft tag in the database, and appends a user_action message to the conversation
 */
export const chatCreateTag = <ThrowOnError extends boolean = false>(options: Options<ChatCreateTagData, ThrowOnError>) => (options.client ?? client).post<ChatCreateTagResponses, ChatCreateTagErrors, ThrowOnError>({
    url: '/api/chatchat-create-tag',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chat Create Event
 *
 * Creates a draft calendar event and appends a user_action message to the conversation.
 */
export const chatCreateEvent = <ThrowOnError extends boolean = false>(options: Options<ChatCreateEventData, ThrowOnError>) => (options.client ?? client).post<ChatCreateEventResponses, ChatCreateEventErrors, ThrowOnError>({
    url: '/api/chatchat-create-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chat Update Event
 *
 * Update a calendar event from the chat OEW.
 */
export const chatUpdateEvent = <ThrowOnError extends boolean = false>(options: Options<ChatUpdateEventData, ThrowOnError>) => (options.client ?? client).post<ChatUpdateEventResponses, ChatUpdateEventErrors, ThrowOnError>({
    url: '/api/chatchat-update-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chat Delete Objects
 *
 * Delete multiple objects (artifacts, tags, events) in a single request (user action).
 * Inserts a user_action message for each deleted object into the conversation.
 */
export const chatDeleteObjects = <ThrowOnError extends boolean = false>(options: Options<ChatDeleteObjectsData, ThrowOnError>) => (options.client ?? client).post<ChatDeleteObjectsResponses, ChatDeleteObjectsErrors, ThrowOnError>({
    url: '/api/chatchat-delete-objects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Chat
 */
export const getChat = <ThrowOnError extends boolean = false>(options: Options<GetChatData, ThrowOnError>) => (options.client ?? client).post<GetChatResponses, GetChatErrors, ThrowOnError>({
    url: '/api/chat/get-chat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Conversation History
 *
 * Compressed history of one of the user's conversations, for following an H citation.
 *
 * With start_time/end_time, returns the cited rows plus up to
 * HISTORY_VIEW_CONTEXT_ROWS rows on each side, with the cited ones flagged.
 */
export const getConversationHistory = <ThrowOnError extends boolean = false>(options: Options<GetConversationHistoryData, ThrowOnError>) => (options.client ?? client).post<GetConversationHistoryResponses, GetConversationHistoryErrors, ThrowOnError>({
    url: '/api/chat/get-conversation-history',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Draft Objects
 *
 * Draft artifacts and tags referenced by each of the user's conversations in the
 * active organisation: created by the user (user_action) or by the agent (tool_result),
 * including references that compression moved into the history object index.
 */
export const getDraftObjects = <ThrowOnError extends boolean = false>(options?: Options<GetDraftObjectsData, ThrowOnError>) => (options?.client ?? client).post<GetDraftObjectsResponses, GetDraftObjectsErrors, ThrowOnError>({ url: '/api/chat/get-draft-objects', ...options });

/**
 * Get Client View Chat
 *
 * Return the conversation as it would be serialized and sent to the LLM client (Claude).
 * Includes system prompts, the memory context, and the full parse_messages output.
 */
export const getClientViewChat = <ThrowOnError extends boolean = false>(options: Options<GetClientViewChatData, ThrowOnError>) => (options.client ?? client).post<GetClientViewChatResponses, GetClientViewChatErrors, ThrowOnError>({
    url: '/api/chat/get-client-view-chat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export Conversation Snapshot
 *
 * Export a conversation verbatim as a chat-evaluation context snapshot.
 *
 * Unlike /get-client-view-chat this is lossless: the raw content_json of every
 * stored message plus the conversation's tag scope, which is what the
 * evaluation sandbox needs to replay the turn faithfully.
 */
export const exportConversationSnapshot = <ThrowOnError extends boolean = false>(options: Options<ExportConversationSnapshotData, ThrowOnError>) => (options.client ?? client).post<ExportConversationSnapshotResponses, ExportConversationSnapshotErrors, ThrowOnError>({
    url: '/api/chat/export-conversation-snapshot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset Chat
 */
export const resetChat = <ThrowOnError extends boolean = false>(options: Options<ResetChatData, ThrowOnError>) => (options.client ?? client).post<ResetChatResponses, ResetChatErrors, ThrowOnError>({
    url: '/api/chat/reset-chat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Active Agent
 */
export const setActiveAgent = <ThrowOnError extends boolean = false>(options: Options<SetActiveAgentData, ThrowOnError>) => (options.client ?? client).post<SetActiveAgentResponses, SetActiveAgentErrors, ThrowOnError>({
    url: '/api/chat/set-active-agent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Tool Use
 */
export const getToolUse = <ThrowOnError extends boolean = false>(options: Options<GetToolUseData, ThrowOnError>) => (options.client ?? client).post<GetToolUseResponses, GetToolUseErrors, ThrowOnError>({
    url: '/api/chat/get-tool-use',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Skills
 */
export const listSkills = <ThrowOnError extends boolean = false>(options?: Options<ListSkillsData, ThrowOnError>) => (options?.client ?? client).post<ListSkillsResponses, ListSkillsErrors, ThrowOnError>({ url: '/api/chat/list-skills', ...options });

/**
 * Emit User Action
 */
export const emitUserAction = <ThrowOnError extends boolean = false>(options: Options<EmitUserActionData, ThrowOnError>) => (options.client ?? client).post<EmitUserActionResponses, EmitUserActionErrors, ThrowOnError>({
    url: '/api/chat/emit-user-action',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Create Agent
 *
 * Create a prompt set owned by the addressed organisation.
 */
export const adminCreateAgent = <ThrowOnError extends boolean = false>(options: Options<AdminCreateAgentData, ThrowOnError>) => (options.client ?? client).post<AdminCreateAgentResponses, AdminCreateAgentErrors, ThrowOnError>({
    url: '/api/agents/create-agent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Update Agent
 *
 * Update a prompt set. Only the owning organisation may edit it.
 */
export const adminUpdateAgent = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateAgentData, ThrowOnError>) => (options.client ?? client).post<AdminUpdateAgentResponses, AdminUpdateAgentErrors, ThrowOnError>({
    url: '/api/agents/update-agent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Get Agents
 *
 * List prompt sets for an organisation (owned + assigned default).
 */
export const adminGetAgents = <ThrowOnError extends boolean = false>(options: Options<AdminGetAgentsData, ThrowOnError>) => (options.client ?? client).post<AdminGetAgentsResponses, AdminGetAgentsErrors, ThrowOnError>({
    url: '/api/agents/get-agents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Get Agent
 *
 * Get a prompt set by id if it is owned by the addressed org or assigned as
 * that org's default. Assigned-from-elsewhere sets are returned read-only.
 */
export const adminGetAgent = <ThrowOnError extends boolean = false>(options: Options<AdminGetAgentData, ThrowOnError>) => (options.client ?? client).post<AdminGetAgentResponses, AdminGetAgentErrors, ThrowOnError>({
    url: '/api/agents/get-agent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Delete Agent
 *
 * Delete a prompt set owned by the addressed organisation.
 */
export const adminDeleteAgent = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteAgentData, ThrowOnError>) => (options.client ?? client).post<AdminDeleteAgentResponses, AdminDeleteAgentErrors, ThrowOnError>({
    url: '/api/agents/delete-agent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Delete Agents
 *
 * Bulk-delete prompt sets owned by the addressed organisation.
 */
export const adminDeleteAgents = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteAgentsData, ThrowOnError>) => (options.client ?? client).post<AdminDeleteAgentsResponses, AdminDeleteAgentsErrors, ThrowOnError>({
    url: '/api/agents/delete-agents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Agents Overview
 *
 * Get prompt-set overview (which orgs have which default assigned).
 * Only authenticated super admin users can access this endpoint.
 */
export const getAgentsOverview = <ThrowOnError extends boolean = false>(options?: Options<GetAgentsOverviewData, ThrowOnError>) => (options?.client ?? client).get<GetAgentsOverviewResponses, GetAgentsOverviewErrors, ThrowOnError>({ url: '/api/agents/get-agents-overview', ...options });

/**
 * Get Organisations
 *
 * Update an organisation's active agent.
 */
export const getOrganisations = <ThrowOnError extends boolean = false>(options?: Options<GetOrganisationsData, ThrowOnError>) => (options?.client ?? client).get<GetOrganisationsResponses, GetOrganisationsErrors, ThrowOnError>({ url: '/api/organisations/get-organisations', ...options });

/**
 * Get Organisation Tree
 *
 * Every organisation the user can reach, with the structure and state the
 * system settings page needs to render the tree without a request per node:
 * parent link, assigned default prompt set, demo flag, and which organisation
 * actually carries the payment for this branch.
 */
export const getOrganisationTree = <ThrowOnError extends boolean = false>(options?: Options<GetOrganisationTreeData, ThrowOnError>) => (options?.client ?? client).get<GetOrganisationTreeResponses, GetOrganisationTreeErrors, ThrowOnError>({ url: '/api/organisations/get-organisation-tree', ...options });

/**
 * Get Avalible Agents In Child Organisation
 *
 * Prompt sets that may be assigned as the child's default: sets owned by
 * the actor's active org, sets owned by the child, and the child's
 * currently assigned default.
 */
export const getAvalibleAgentsInChildOrganisation = <ThrowOnError extends boolean = false>(options: Options<GetAvalibleAgentsInChildOrganisationData, ThrowOnError>) => (options.client ?? client).post<GetAvalibleAgentsInChildOrganisationResponses, GetAvalibleAgentsInChildOrganisationErrors, ThrowOnError>({
    url: '/api/organisations/get-avalible-agents-in-child-organisation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Active Organisation
 */
export const setActiveOrganisation = <ThrowOnError extends boolean = false>(options: Options<SetActiveOrganisationData, ThrowOnError>) => (options.client ?? client).post<SetActiveOrganisationResponses, SetActiveOrganisationErrors, ThrowOnError>({
    url: '/api/organisations/set-active-organisation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Organisation
 */
export const getOrganisation = <ThrowOnError extends boolean = false>(options: Options<GetOrganisationData, ThrowOnError>) => (options.client ?? client).post<GetOrganisationResponses, GetOrganisationErrors, ThrowOnError>({
    url: '/api/organisations/get-organisation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Child Organisations
 *
 * Retuns child organisations and the active organisation of the current user
 * if the current user is an administrator of the active organisation.
 */
export const getChildOrganisations = <ThrowOnError extends boolean = false>(options?: Options<GetChildOrganisationsData, ThrowOnError>) => (options?.client ?? client).get<GetChildOrganisationsResponses, GetChildOrganisationsErrors, ThrowOnError>({ url: '/api/organisations/get-child-organisations', ...options });

/**
 * Create Organisation
 */
export const createOrganisation = <ThrowOnError extends boolean = false>(options: Options<CreateOrganisationData, ThrowOnError>) => (options.client ?? client).post<CreateOrganisationResponses, CreateOrganisationErrors, ThrowOnError>({
    url: '/api/organisations/create-organisation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Organisation
 */
export const updateOrganisation = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganisationData, ThrowOnError>) => (options.client ?? client).post<UpdateOrganisationResponses, UpdateOrganisationErrors, ThrowOnError>({
    url: '/api/organisations/update-organisation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate Organisation
 */
export const deactivateOrganisation = <ThrowOnError extends boolean = false>(options: Options<DeactivateOrganisationData, ThrowOnError>) => (options.client ?? client).post<DeactivateOrganisationResponses, DeactivateOrganisationErrors, ThrowOnError>({
    url: '/api/organisations/deactivate-organisation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate Organisations
 */
export const deactivateOrganisations = <ThrowOnError extends boolean = false>(options: Options<DeactivateOrganisationsData, ThrowOnError>) => (options.client ?? client).post<DeactivateOrganisationsResponses, DeactivateOrganisationsErrors, ThrowOnError>({
    url: '/api/organisations/deactivate-organisations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Payment Information
 */
export const getPaymentInformation = <ThrowOnError extends boolean = false>(options: Options<GetPaymentInformationData, ThrowOnError>) => (options.client ?? client).post<GetPaymentInformationResponses, GetPaymentInformationErrors, ThrowOnError>({
    url: '/api/organisations/get-payment-information',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Payment Information
 */
export const updatePaymentInformation = <ThrowOnError extends boolean = false>(options: Options<UpdatePaymentInformationData, ThrowOnError>) => (options.client ?? client).post<UpdatePaymentInformationResponses, UpdatePaymentInformationErrors, ThrowOnError>({
    url: '/api/organisations/update-payment-information',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Grant Demo Access
 *
 * Grant demo access to a child organisation.
 */
export const grantDemoAccess = <ThrowOnError extends boolean = false>(options: Options<GrantDemoAccessData, ThrowOnError>) => (options.client ?? client).post<GrantDemoAccessResponses, GrantDemoAccessErrors, ThrowOnError>({
    url: '/api/organisations/grant-demo-access',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Demo Access
 *
 * Revoke demo access from a child organisation.
 */
export const revokeDemoAccess = <ThrowOnError extends boolean = false>(options: Options<RevokeDemoAccessData, ThrowOnError>) => (options.client ?? client).post<RevokeDemoAccessResponses, RevokeDemoAccessErrors, ThrowOnError>({
    url: '/api/organisations/revoke-demo-access',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Create Tag
 *
 * Create tag.
 * Only authenticated admin users can access this endpoint.
 */
export const adminCreateTag = <ThrowOnError extends boolean = false>(options: Options<AdminCreateTagData, ThrowOnError>) => (options.client ?? client).post<AdminCreateTagResponses, AdminCreateTagErrors, ThrowOnError>({
    url: '/api/tags/create_tag',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Update Tag
 *
 * Update tag.
 * Only authenticated admin users can access this endpoint.
 */
export const adminUpdateTag = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateTagData, ThrowOnError>) => (options.client ?? client).post<AdminUpdateTagResponses, AdminUpdateTagErrors, ThrowOnError>({
    url: '/api/tags/update_tag',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Get Tags
 *
 * Get tags.
 * Only authenticated admin users can access this endpoint.
 */
export const adminGetTags = <ThrowOnError extends boolean = false>(options: Options<AdminGetTagsData, ThrowOnError>) => (options.client ?? client).post<AdminGetTagsResponses, AdminGetTagsErrors, ThrowOnError>({
    url: '/api/tags/get_tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Get Tag
 *
 * Get tag.
 * Only authenticated admin users can access this endpoint.
 */
export const adminGetTag = <ThrowOnError extends boolean = false>(options: Options<AdminGetTagData, ThrowOnError>) => (options.client ?? client).post<AdminGetTagResponses, AdminGetTagErrors, ThrowOnError>({
    url: '/api/tags/get_tag',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Delete Tag
 *
 * Delete tag.
 * Only authenticated admin users can access this endpoint.
 */
export const adminDeleteTag = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteTagData, ThrowOnError>) => (options.client ?? client).post<AdminDeleteTagResponses, AdminDeleteTagErrors, ThrowOnError>({
    url: '/api/tags/delete_tag',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Delete Tags
 *
 * Delete tags.
 * Only authenticated admin users can access this endpoint.
 */
export const adminDeleteTags = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteTagsData, ThrowOnError>) => (options.client ?? client).post<AdminDeleteTagsResponses, AdminDeleteTagsErrors, ThrowOnError>({
    url: '/api/tags/delete_tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Tag Events
 *
 * Get all calendar events associated with a tag.
 */
export const getTagEvents = <ThrowOnError extends boolean = false>(options: Options<GetTagEventsData, ThrowOnError>) => (options.client ?? client).get<GetTagEventsResponses, GetTagEventsErrors, ThrowOnError>({ url: '/api/tags/{tag_id}/events', ...options });

/**
 * Update Tag Speaker Profile
 *
 * Update the speaker_profile attribute on a tag's JSON attributes.
 */
export const updateTagSpeakerProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateTagSpeakerProfileData, ThrowOnError>) => (options.client ?? client).post<UpdateTagSpeakerProfileResponses, UpdateTagSpeakerProfileErrors, ThrowOnError>({
    url: '/api/tags/update_tag_speaker_profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Getwebpages
 *
 * Returns content for the sites public webpages
 */
export const getWebPages = <ThrowOnError extends boolean = false>(options?: Options<GetWebPagesData, ThrowOnError>) => (options?.client ?? client).get<GetWebPagesResponses, unknown, ThrowOnError>({ url: '/api/webpages/get-webpages', ...options });

/**
 * Getwebpage
 *
 * Returns content for the page
 */
export const getWebPage = <ThrowOnError extends boolean = false>(options: Options<GetWebPageData, ThrowOnError>) => (options.client ?? client).post<GetWebPageResponses, GetWebPageErrors, ThrowOnError>({
    url: '/api/webpages/get-webpage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Latest Chats
 */
export const getLatestChats = <ThrowOnError extends boolean = false>(options?: Options<GetLatestChatsData, ThrowOnError>) => (options?.client ?? client).get<GetLatestChatsResponses, GetLatestChatsErrors, ThrowOnError>({ url: '/api/workspaces/get-latest-chats', ...options });

/**
 * Get Upcoming Events
 */
export const getUpcomingEvents = <ThrowOnError extends boolean = false>(options?: Options<GetUpcomingEventsData, ThrowOnError>) => (options?.client ?? client).get<GetUpcomingEventsResponses, GetUpcomingEventsErrors, ThrowOnError>({ url: '/api/workspaces/get-upcoming-events', ...options });

/**
 * Calendar Sync Status
 */
export const calendarSyncStatus = <ThrowOnError extends boolean = false>(options?: Options<CalendarSyncStatusData, ThrowOnError>) => (options?.client ?? client).get<CalendarSyncStatusResponses, CalendarSyncStatusErrors, ThrowOnError>({ url: '/api/calendar/sync-status', ...options });

/**
 * Sync All Clients
 */
export const syncAllClients = <ThrowOnError extends boolean = false>(options?: Options<SyncAllClientsData, ThrowOnError>) => (options?.client ?? client).post<SyncAllClientsResponses, SyncAllClientsErrors, ThrowOnError>({ url: '/api/calendar/sync-all-clients', ...options });

/**
 * Disable Client Sync
 */
export const disableClientSync = <ThrowOnError extends boolean = false>(options?: Options<DisableClientSyncData, ThrowOnError>) => (options?.client ?? client).post<DisableClientSyncResponses, DisableClientSyncErrors, ThrowOnError>({ url: '/api/calendar/disable-client-sync', ...options });

/**
 * Watch Calendar Endpoint
 *
 * Register a webhook listener for a specific tag's calendar.
 * Requires a public HTTPS URL.
 */
export const watchCalendarEndpoint = <ThrowOnError extends boolean = false>(options: Options<WatchCalendarEndpointData, ThrowOnError>) => (options.client ?? client).post<WatchCalendarEndpointResponses, WatchCalendarEndpointErrors, ThrowOnError>({
    url: '/api/calendar/watch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Handle Google Calendar Webhook
 *
 * Handle incoming webhook notifications from Google Calendar.
 * Returns 200 immediately and processes in the background so Google
 * doesn't time out and stop delivering to this channel.
 */
export const handleGoogleCalendarWebhook = <ThrowOnError extends boolean = false>(options?: Options<HandleGoogleCalendarWebhookData, ThrowOnError>) => (options?.client ?? client).post<HandleGoogleCalendarWebhookResponses, HandleGoogleCalendarWebhookErrors, ThrowOnError>({ url: '/api/calendar/webhooks/google-calendar', ...options });

/**
 * Ensure Watches
 *
 * Ensures all Google Calendar watches are active for the current user.
 * Call this on page load / app init so that a browser refresh recovers
 * any dropped connections.
 */
export const ensureWatches = <ThrowOnError extends boolean = false>(options?: Options<EnsureWatchesData, ThrowOnError>) => (options?.client ?? client).post<EnsureWatchesResponses, EnsureWatchesErrors, ThrowOnError>({ url: '/api/calendar/ensure-watches', ...options });

/**
 * Create Local Calendar For Tag
 *
 * Create a local-only calendar for a tag (no Google sync).
 * This inserts a calendars row with google_calendar_id = NULL.
 */
export const createLocalCalendarForTag = <ThrowOnError extends boolean = false>(options: Options<CreateLocalCalendarForTagData, ThrowOnError>) => (options.client ?? client).post<CreateLocalCalendarForTagResponses, CreateLocalCalendarForTagErrors, ThrowOnError>({
    url: '/api/calendar/create-local-calendar',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Service Calendar With Google
 *
 * Connect an existing local calendar to Google Calendar.
 * Fails if the tag does not already have a local calendar.
 * No-ops if already linked to Google.
 */
export const serviceCalendarWithGoogle = <ThrowOnError extends boolean = false>(options: Options<ServiceCalendarWithGoogleData, ThrowOnError>) => (options.client ?? client).post<ServiceCalendarWithGoogleResponses, ServiceCalendarWithGoogleErrors, ThrowOnError>({
    url: '/api/calendar/service-calendar-with-google',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sync Calendar
 *
 * Manually trigger sync for a specific tag's calendar.
 * Currently Google-only; extend with elif for Microsoft.
 */
export const syncCalendar = <ThrowOnError extends boolean = false>(options: Options<SyncCalendarData, ThrowOnError>) => (options.client ?? client).post<SyncCalendarResponses, SyncCalendarErrors, ThrowOnError>({ url: '/api/calendar/sync/{tag_id}', ...options });

/**
 * Get Events
 *
 * Get all calendar events belonging to tags the user has write access to.
 * Two queries: 1) get writable tag_ids, 2) get events for those tags' calendars.
 */
export const getEvents = <ThrowOnError extends boolean = false>(options: Options<GetEventsData, ThrowOnError>) => (options.client ?? client).post<GetEventsResponses, GetEventsErrors, ThrowOnError>({
    url: '/api/events/get-events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Event Transcription
 *
 * Get the transcription of a single event by ID, verifying read access.
 */
export const getEventTranscription = <ThrowOnError extends boolean = false>(options: Options<GetEventTranscriptionData, ThrowOnError>) => (options.client ?? client).post<GetEventTranscriptionResponses, GetEventTranscriptionErrors, ThrowOnError>({
    url: '/api/events/get-event-transcription',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Event
 *
 * Get a single event by ID, verifying write access to its tag.
 */
export const getEvent = <ThrowOnError extends boolean = false>(options: Options<GetEventData, ThrowOnError>) => (options.client ?? client).post<GetEventResponses, GetEventErrors, ThrowOnError>({
    url: '/api/events/get-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Event
 *
 * Create a new calendar event. Requires write access to the tag.
 * If no calendar exists for the tag yet, one is auto-created.
 */
export const createEvent = <ThrowOnError extends boolean = false>(options: Options<CreateEventData, ThrowOnError>) => (options.client ?? client).post<CreateEventResponses, CreateEventErrors, ThrowOnError>({
    url: '/api/events/create-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Event
 *
 * Update an existing calendar event. Requires write access to its tag.
 */
export const updateEvent = <ThrowOnError extends boolean = false>(options: Options<UpdateEventData, ThrowOnError>) => (options.client ?? client).post<UpdateEventResponses, UpdateEventErrors, ThrowOnError>({
    url: '/api/events/update-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Event
 *
 * Soft-delete an event. Requires write access to its tag.
 */
export const deleteEvent = <ThrowOnError extends boolean = false>(options: Options<DeleteEventData, ThrowOnError>) => (options.client ?? client).post<DeleteEventResponses, DeleteEventErrors, ThrowOnError>({
    url: '/api/events/delete-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Event Transcription Summary
 *
 * Save-and-summarise entry point.
 *
 * Long transcription (>= SUMMARISATION_MIN_TRANSCRIPTION_CHARS):
 * take locks.event_locks, spawn generate_transcription_summary, return
 * ``{started: true}``. OEW polls is_summarizing until the LLM writes
 * transcription_summary.
 *
 * Short transcription (below the gate, but not empty):
 * persist_unsummarised_transcription sets transcription_unsummarised and
 * stores clinician notes, leaves transcription_summary NULL, returns
 * ``{started: true, complete: true}``. No lock, no LLM, no billing.
 * OEW treats unsummarised like saved (glow off). Bare event/read returns
 * numbered transcription plus notes, not source: summary.
 *
 * Do not reintroduce a skip-modal / "too short to summarise" path, and do
 * not copy the transcript into transcription_summary.
 * Empty transcription is still 400.
 */
export const generateEventTranscriptionSummary = <ThrowOnError extends boolean = false>(options: Options<GenerateEventTranscriptionSummaryData, ThrowOnError>) => (options.client ?? client).post<GenerateEventTranscriptionSummaryResponses, GenerateEventTranscriptionSummaryErrors, ThrowOnError>({
    url: '/api/events/generate-event-transcription-summary',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Transcription
 *
 * Endpoint to fetch the current transcription text for a given event.
 */
export const getTranscription = <ThrowOnError extends boolean = false>(options: Options<GetTranscriptionData, ThrowOnError>) => (options.client ?? client).post<GetTranscriptionResponses, GetTranscriptionErrors, ThrowOnError>({
    url: '/api/transcription/get_transcription',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear Transcription
 *
 * Endpoint to clear the transcription text for a given event.
 */
export const clearTranscription = <ThrowOnError extends boolean = false>(options: Options<ClearTranscriptionData, ThrowOnError>) => (options.client ?? client).post<ClearTranscriptionResponses, ClearTranscriptionErrors, ThrowOnError>({
    url: '/api/transcription/clear_transcription',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Atot Token
 */
export const getAtotToken = <ThrowOnError extends boolean = false>(options?: Options<GetAtotTokenData, ThrowOnError>) => (options?.client ?? client).get<GetAtotTokenResponses, unknown, ThrowOnError>({ url: '/api/transcription/get_atot_token', ...options });

/**
 * Setup Payment Method
 */
export const setupPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<SetupPaymentMethodData, ThrowOnError>) => (options.client ?? client).post<SetupPaymentMethodResponses, SetupPaymentMethodErrors, ThrowOnError>({
    url: '/api/billing/setup-payment-method',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sync Checkout
 */
export const syncCheckout = <ThrowOnError extends boolean = false>(options: Options<SyncCheckoutData, ThrowOnError>) => (options.client ?? client).post<SyncCheckoutResponses, SyncCheckoutErrors, ThrowOnError>({
    url: '/api/billing/sync-checkout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mollie Webhook
 */
export const mollieWebhook = <ThrowOnError extends boolean = false>(options: Options<MollieWebhookData, ThrowOnError>) => (options.client ?? client).post<MollieWebhookResponses, MollieWebhookErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/api/billing/mollie-webhook',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Mollie Test Webhook
 *
 * Webhooks for billing sandbox payments, which only the test key can read.
 */
export const mollieTestWebhook = <ThrowOnError extends boolean = false>(options: Options<MollieTestWebhookData, ThrowOnError>) => (options.client ?? client).post<MollieTestWebhookResponses, MollieTestWebhookErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/api/billing/mollie-webhook/test',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Billing Status
 */
export const billingStatus = <ThrowOnError extends boolean = false>(options: Options<BillingStatusData, ThrowOnError>) => (options.client ?? client).post<BillingStatusResponses, BillingStatusErrors, ThrowOnError>({
    url: '/api/billing/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Usage Ceiling
 */
export const setUsageCeiling = <ThrowOnError extends boolean = false>(options: Options<SetUsageCeilingData, ThrowOnError>) => (options.client ?? client).post<SetUsageCeilingResponses, SetUsageCeilingErrors, ThrowOnError>({
    url: '/api/billing/set-usage-ceiling',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Usage Meter
 *
 * This month's meter for the organisation the user works in, for the speedometer.
 */
export const usageMeter = <ThrowOnError extends boolean = false>(options?: Options<UsageMeterData, ThrowOnError>) => (options?.client ?? client).get<UsageMeterResponses, UsageMeterErrors, ThrowOnError>({ url: '/api/billing/meter', ...options });

/**
 * List Invoices
 */
export const listInvoices = <ThrowOnError extends boolean = false>(options: Options<ListInvoicesData, ThrowOnError>) => (options.client ?? client).post<ListInvoicesResponses, ListInvoicesErrors, ThrowOnError>({
    url: '/api/billing/invoices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invoice Pdf
 */
export const invoicePdf = <ThrowOnError extends boolean = false>(options: Options<InvoicePdfData, ThrowOnError>) => (options.client ?? client).post<InvoicePdfResponses, InvoicePdfErrors, ThrowOnError>({
    url: '/api/billing/invoice-pdf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sandbox List
 */
export const sandboxList = <ThrowOnError extends boolean = false>(options?: Options<SandboxListData, ThrowOnError>) => (options?.client ?? client).get<SandboxListResponses, SandboxListErrors, ThrowOnError>({ url: '/api/billing/sandbox/list', ...options });

/**
 * Sandbox Create
 *
 * A new organisation with a test-mode billing account. It sits under the
 * creator's own organisation unless another parent is given, so the creator
 * administers it through their propagated permission.
 */
export const sandboxCreate = <ThrowOnError extends boolean = false>(options: Options<SandboxCreateData, ThrowOnError>) => (options.client ?? client).post<SandboxCreateResponses, SandboxCreateErrors, ThrowOnError>({
    url: '/api/billing/sandbox/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sandbox Reset
 *
 * Back to a fresh sandbox: no card, no ceiling, no usage, no documents.
 */
export const sandboxReset = <ThrowOnError extends boolean = false>(options: Options<SandboxResetData, ThrowOnError>) => (options.client ?? client).post<SandboxResetResponses, SandboxResetErrors, ThrowOnError>({
    url: '/api/billing/sandbox/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sandbox Delete
 *
 * Remove the sandbox and its child organisations. Falls back to deactivating them.
 */
export const sandboxDelete = <ThrowOnError extends boolean = false>(options: Options<SandboxDeleteData, ThrowOnError>) => (options.client ?? client).post<SandboxDeleteResponses, SandboxDeleteErrors, ThrowOnError>({
    url: '/api/billing/sandbox/delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sandbox Flags
 *
 * Hold webhooks, simulate a Mollie outage, or join the next real 1st-of-month run.
 */
export const sandboxFlags = <ThrowOnError extends boolean = false>(options: Options<SandboxFlagsData, ThrowOnError>) => (options.client ?? client).post<SandboxFlagsResponses, SandboxFlagsErrors, ThrowOnError>({
    url: '/api/billing/sandbox/flags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sandbox State
 *
 * Everything the Billing Lab shows: our rows, Mollie's view of them, the meter.
 */
export const sandboxState = <ThrowOnError extends boolean = false>(options: Options<SandboxStateData, ThrowOnError>) => (options.client ?? client).post<SandboxStateResponses, SandboxStateErrors, ThrowOnError>({
    url: '/api/billing/sandbox/state',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sandbox Inject Usage
 *
 * A ledger row the way record_message_usage writes it, at a chosen moment.
 */
export const sandboxInjectUsage = <ThrowOnError extends boolean = false>(options: Options<SandboxInjectUsageData, ThrowOnError>) => (options.client ?? client).post<SandboxInjectUsageResponses, SandboxInjectUsageErrors, ThrowOnError>({
    url: '/api/billing/sandbox/inject-usage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sandbox Run Job
 *
 * Run a scheduled billing job for this sandbox only. ``monthly`` is the
 * 1st-of-month run: the same function the cron calls at 04:00 on the 1st.
 */
export const sandboxRunJob = <ThrowOnError extends boolean = false>(options: Options<SandboxRunJobData, ThrowOnError>) => (options.client ?? client).post<SandboxRunJobResponses, SandboxRunJobErrors, ThrowOnError>({
    url: '/api/billing/sandbox/run-job',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sandbox Refund
 *
 * Refund a paid charge through the Mollie Refunds API and apply the result.
 */
export const sandboxRefund = <ThrowOnError extends boolean = false>(options: Options<SandboxRefundData, ThrowOnError>) => (options.client ?? client).post<SandboxRefundResponses, SandboxRefundErrors, ThrowOnError>({
    url: '/api/billing/sandbox/refund',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sandbox Webhook
 *
 * Release, repeat or drop a held webhook, or apply any sandbox payment as if its webhook arrived.
 */
export const sandboxWebhook = <ThrowOnError extends boolean = false>(options: Options<SandboxWebhookData, ThrowOnError>) => (options.client ?? client).post<SandboxWebhookResponses, SandboxWebhookErrors, ThrowOnError>({
    url: '/api/billing/sandbox/webhook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sandbox Expire Grace
 *
 * Move a past-due account to just after its grace period, so usage is blocked.
 */
export const sandboxExpireGrace = <ThrowOnError extends boolean = false>(options: Options<SandboxExpireGraceData, ThrowOnError>) => (options.client ?? client).post<SandboxExpireGraceResponses, SandboxExpireGraceErrors, ThrowOnError>({
    url: '/api/billing/sandbox/expire-grace',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sandbox Revoke Mandate
 *
 * Revoke the card mandate at Mollie, as a bank or the customer would. Our
 * copy is left alone: the next charge finds out from Mollie.
 */
export const sandboxRevokeMandate = <ThrowOnError extends boolean = false>(options: Options<SandboxRevokeMandateData, ThrowOnError>) => (options.client ?? client).post<SandboxRevokeMandateResponses, SandboxRevokeMandateErrors, ThrowOnError>({
    url: '/api/billing/sandbox/revoke-mandate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Kvp
 */
export const getKvp = <ThrowOnError extends boolean = false>(options?: Options<GetKvpData, ThrowOnError>) => (options?.client ?? client).post<GetKvpResponses, GetKvpErrors, ThrowOnError>({ url: '/api/kvp/get-kvp', ...options });

/**
 * Set Kvp
 */
export const setKvp = <ThrowOnError extends boolean = false>(options: Options<SetKvpData, ThrowOnError>) => (options.client ?? client).post<SetKvpResponses, SetKvpErrors, ThrowOnError>({
    url: '/api/kvp/set-kvp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Kvp
 */
export const deleteKvp = <ThrowOnError extends boolean = false>(options: Options<DeleteKvpData, ThrowOnError>) => (options.client ?? client).post<DeleteKvpResponses, DeleteKvpErrors, ThrowOnError>({
    url: '/api/kvp/delete-kvp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Llm Providers
 */
export const listLlmProviders = <ThrowOnError extends boolean = false>(options?: Options<ListLlmProvidersData, ThrowOnError>) => (options?.client ?? client).post<ListLlmProvidersResponses, ListLlmProvidersErrors, ThrowOnError>({ url: '/api/llm-models/list-providers', ...options });

/**
 * Check Llm Provider
 */
export const checkLlmProvider = <ThrowOnError extends boolean = false>(options: Options<CheckLlmProviderData, ThrowOnError>) => (options.client ?? client).post<CheckLlmProviderResponses, CheckLlmProviderErrors, ThrowOnError>({
    url: '/api/llm-models/test-provider',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Llm Models
 */
export const listLlmModels = <ThrowOnError extends boolean = false>(options: Options<ListLlmModelsData, ThrowOnError>) => (options.client ?? client).post<ListLlmModelsResponses, ListLlmModelsErrors, ThrowOnError>({
    url: '/api/llm-models/list-models',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sync Llm Models
 */
export const syncLlmModels = <ThrowOnError extends boolean = false>(options?: Options<SyncLlmModelsData, ThrowOnError>) => (options?.client ?? client).post<SyncLlmModelsResponses, SyncLlmModelsErrors, ThrowOnError>({ url: '/api/llm-models/sync-models', ...options });

/**
 * Update Llm Model
 */
export const updateLlmModel = <ThrowOnError extends boolean = false>(options: Options<UpdateLlmModelData, ThrowOnError>) => (options.client ?? client).post<UpdateLlmModelResponses, UpdateLlmModelErrors, ThrowOnError>({
    url: '/api/llm-models/update-model',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Llm Model Assignments
 */
export const listLlmModelAssignments = <ThrowOnError extends boolean = false>(options?: Options<ListLlmModelAssignmentsData, ThrowOnError>) => (options?.client ?? client).post<ListLlmModelAssignmentsResponses, ListLlmModelAssignmentsErrors, ThrowOnError>({ url: '/api/llm-models/list-assignments', ...options });

/**
 * Set Llm Model Assignment
 */
export const setLlmModelAssignment = <ThrowOnError extends boolean = false>(options: Options<SetLlmModelAssignmentData, ThrowOnError>) => (options.client ?? client).post<SetLlmModelAssignmentResponses, SetLlmModelAssignmentErrors, ThrowOnError>({
    url: '/api/llm-models/set-assignment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get I18N Locales
 */
export const getI18nLocales = <ThrowOnError extends boolean = false>(options?: Options<GetI18nLocalesData, ThrowOnError>) => (options?.client ?? client).get<GetI18nLocalesResponses, unknown, ThrowOnError>({ url: '/api/i18n/locales', ...options });

/**
 * Get I18N
 */
export const getI18N = <ThrowOnError extends boolean = false>(options?: Options<GetI18nData, ThrowOnError>) => (options?.client ?? client).get<GetI18nResponses, GetI18nErrors, ThrowOnError>({ url: '/api/i18n/strings', ...options });

/**
 * Get I18N Admin
 */
export const getI18nAdmin = <ThrowOnError extends boolean = false>(options?: Options<GetI18nAdminData, ThrowOnError>) => (options?.client ?? client).post<GetI18nAdminResponses, GetI18nAdminErrors, ThrowOnError>({ url: '/api/i18n/get-all', ...options });

/**
 * Set I18N
 */
export const setI18N = <ThrowOnError extends boolean = false>(options: Options<SetI18nData, ThrowOnError>) => (options.client ?? client).post<SetI18nResponses, SetI18nErrors, ThrowOnError>({
    url: '/api/i18n/set',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete I18N
 */
export const deleteI18N = <ThrowOnError extends boolean = false>(options: Options<DeleteI18nData, ThrowOnError>) => (options.client ?? client).post<DeleteI18nResponses, DeleteI18nErrors, ThrowOnError>({
    url: '/api/i18n/delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Usage Cost By User
 */
export const usageCostByUser = <ThrowOnError extends boolean = false>(options: Options<UsageCostByUserData, ThrowOnError>) => (options.client ?? client).post<UsageCostByUserResponses, UsageCostByUserErrors, ThrowOnError>({
    url: '/api/usage/charts/cost-by-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Usage Revenue By User
 */
export const usageRevenueByUser = <ThrowOnError extends boolean = false>(options: Options<UsageRevenueByUserData, ThrowOnError>) => (options.client ?? client).post<UsageRevenueByUserResponses, UsageRevenueByUserErrors, ThrowOnError>({
    url: '/api/usage/charts/revenue-by-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Usage Net By User
 */
export const usageNetByUser = <ThrowOnError extends boolean = false>(options: Options<UsageNetByUserData, ThrowOnError>) => (options.client ?? client).post<UsageNetByUserResponses, UsageNetByUserErrors, ThrowOnError>({
    url: '/api/usage/charts/net-by-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Active
 *
 * Disabled rows are skipped by precompute and by matchmaking, but keep their
 * cached summaries and match history so re-enabling is close to free.
 */
export const setActive = <ThrowOnError extends boolean = false>(options: Options<SetActiveData, ThrowOnError>) => (options.client ?? client).post<SetActiveResponses, SetActiveErrors, ThrowOnError>({
    url: '/api/summarisation-tests/set-active',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Prompts
 */
export const listPrompts = <ThrowOnError extends boolean = false>(options?: Options<ListPromptsData, ThrowOnError>) => (options?.client ?? client).post<ListPromptsResponses, ListPromptsErrors, ThrowOnError>({ url: '/api/summarisation-tests/list-prompts', ...options });

/**
 * Create Prompt
 */
export const createPrompt = <ThrowOnError extends boolean = false>(options: Options<CreatePromptData, ThrowOnError>) => (options.client ?? client).post<CreatePromptResponses, CreatePromptErrors, ThrowOnError>({
    url: '/api/summarisation-tests/create-prompt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Prompt
 */
export const updatePrompt = <ThrowOnError extends boolean = false>(options: Options<UpdatePromptData, ThrowOnError>) => (options.client ?? client).post<UpdatePromptResponses, UpdatePromptErrors, ThrowOnError>({
    url: '/api/summarisation-tests/update-prompt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Prompt
 */
export const deletePrompt = <ThrowOnError extends boolean = false>(options: Options<DeletePromptData, ThrowOnError>) => (options.client ?? client).post<DeletePromptResponses, DeletePromptErrors, ThrowOnError>({
    url: '/api/summarisation-tests/delete-prompt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Events
 */
export const listEvents = <ThrowOnError extends boolean = false>(options?: Options<ListEventsData, ThrowOnError>) => (options?.client ?? client).post<ListEventsResponses, ListEventsErrors, ThrowOnError>({ url: '/api/summarisation-tests/list-events', ...options });

/**
 * Create Event
 */
export const createEvent2 = <ThrowOnError extends boolean = false>(options: Options<CreateEvent2Data, ThrowOnError>) => (options.client ?? client).post<CreateEvent2Responses, CreateEvent2Errors, ThrowOnError>({
    url: '/api/summarisation-tests/create-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Event
 */
export const deleteEvent2 = <ThrowOnError extends boolean = false>(options: Options<DeleteEvent2Data, ThrowOnError>) => (options.client ?? client).post<DeleteEvent2Responses, DeleteEvent2Errors, ThrowOnError>({
    url: '/api/summarisation-tests/delete-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Tests
 */
export const listTests = <ThrowOnError extends boolean = false>(options?: Options<ListTestsData, ThrowOnError>) => (options?.client ?? client).post<ListTestsResponses, ListTestsErrors, ThrowOnError>({ url: '/api/summarisation-tests/list-tests', ...options });

/**
 * Create Test
 */
export const createTest = <ThrowOnError extends boolean = false>(options: Options<CreateTestData, ThrowOnError>) => (options.client ?? client).post<CreateTestResponses, CreateTestErrors, ThrowOnError>({
    url: '/api/summarisation-tests/create-test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Test
 */
export const updateTest = <ThrowOnError extends boolean = false>(options: Options<UpdateTestData, ThrowOnError>) => (options.client ?? client).post<UpdateTestResponses, UpdateTestErrors, ThrowOnError>({
    url: '/api/summarisation-tests/update-test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Test
 */
export const deleteTest = <ThrowOnError extends boolean = false>(options: Options<DeleteTestData, ThrowOnError>) => (options.client ?? client).post<DeleteTestResponses, DeleteTestErrors, ThrowOnError>({
    url: '/api/summarisation-tests/delete-test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run Test
 */
export const runTest = <ThrowOnError extends boolean = false>(options: Options<RunTestData, ThrowOnError>) => (options.client ?? client).post<RunTestResponses, RunTestErrors, ThrowOnError>({
    url: '/api/summarisation-tests/run-test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fill Missing
 */
export const fillMissing = <ThrowOnError extends boolean = false>(options: Options<FillMissingData, ThrowOnError>) => (options.client ?? client).post<FillMissingResponses, FillMissingErrors, ThrowOnError>({
    url: '/api/summarisation-tests/fill-missing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fill Missing All
 */
export const fillMissingAll = <ThrowOnError extends boolean = false>(options?: Options<FillMissingAllData, ThrowOnError>) => (options?.client ?? client).post<FillMissingAllResponses, FillMissingAllErrors, ThrowOnError>({ url: '/api/summarisation-tests/fill-missing-all', ...options });

/**
 * Get Results
 */
export const getResults = <ThrowOnError extends boolean = false>(options: Options<GetResultsData, ThrowOnError>) => (options.client ?? client).post<GetResultsResponses, GetResultsErrors, ThrowOnError>({
    url: '/api/summarisation-tests/get-results',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Progress
 */
export const progress = <ThrowOnError extends boolean = false>(options?: Options<ProgressData, ThrowOnError>) => (options?.client ?? client).post<ProgressResponses, ProgressErrors, ThrowOnError>({ url: '/api/summarisation-tests/progress', ...options });

/**
 * List Models
 */
export const listModels = <ThrowOnError extends boolean = false>(options?: Options<ListModelsData, ThrowOnError>) => (options?.client ?? client).post<ListModelsResponses, ListModelsErrors, ThrowOnError>({ url: '/api/summarisation-tests/list-models', ...options });

/**
 * Create Model
 */
export const createModel = <ThrowOnError extends boolean = false>(options: Options<CreateModelData, ThrowOnError>) => (options.client ?? client).post<CreateModelResponses, CreateModelErrors, ThrowOnError>({
    url: '/api/summarisation-tests/create-model',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Model
 */
export const deleteModel = <ThrowOnError extends boolean = false>(options: Options<DeleteModelData, ThrowOnError>) => (options.client ?? client).post<DeleteModelResponses, DeleteModelErrors, ThrowOnError>({
    url: '/api/summarisation-tests/delete-model',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Judges
 */
export const listJudges = <ThrowOnError extends boolean = false>(options?: Options<ListJudgesData, ThrowOnError>) => (options?.client ?? client).post<ListJudgesResponses, ListJudgesErrors, ThrowOnError>({ url: '/api/summarisation-tests/list-judges', ...options });

/**
 * Next Pair
 */
export const nextPair = <ThrowOnError extends boolean = false>(options: Options<NextPairData, ThrowOnError>) => (options.client ?? client).post<NextPairResponses, NextPairErrors, ThrowOnError>({
    url: '/api/summarisation-tests/next-pair',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cast Vote
 */
export const castVote = <ThrowOnError extends boolean = false>(options: Options<CastVoteData, ThrowOnError>) => (options.client ?? client).post<CastVoteResponses, CastVoteErrors, ThrowOnError>({
    url: '/api/summarisation-tests/cast-vote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear Votes
 */
export const clearVotes = <ThrowOnError extends boolean = false>(options: Options<ClearVotesData, ThrowOnError>) => (options.client ?? client).post<ClearVotesResponses, ClearVotesErrors, ThrowOnError>({
    url: '/api/summarisation-tests/clear-votes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Active
 *
 * Disabled rows are skipped by turn generation and by matchmaking, but keep
 * their cached turns and match history so re-enabling is close to free.
 */
export const setActive2 = <ThrowOnError extends boolean = false>(options: Options<SetActive2Data, ThrowOnError>) => (options.client ?? client).post<SetActive2Responses, SetActive2Errors, ThrowOnError>({
    url: '/api/chat-tests/set-active',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Prompts
 */
export const listPrompts2 = <ThrowOnError extends boolean = false>(options?: Options<ListPrompts2Data, ThrowOnError>) => (options?.client ?? client).post<ListPrompts2Responses, ListPrompts2Errors, ThrowOnError>({ url: '/api/chat-tests/list-prompts', ...options });

/**
 * List Kvp Keys
 *
 * The live kvp table, offered as override candidates in the editor.
 */
export const listKvpKeys = <ThrowOnError extends boolean = false>(options?: Options<ListKvpKeysData, ThrowOnError>) => (options?.client ?? client).post<ListKvpKeysResponses, ListKvpKeysErrors, ThrowOnError>({ url: '/api/chat-tests/list-kvp-keys', ...options });

/**
 * Create Prompt
 */
export const createPrompt2 = <ThrowOnError extends boolean = false>(options: Options<CreatePrompt2Data, ThrowOnError>) => (options.client ?? client).post<CreatePrompt2Responses, CreatePrompt2Errors, ThrowOnError>({
    url: '/api/chat-tests/create-prompt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Prompt
 */
export const updatePrompt2 = <ThrowOnError extends boolean = false>(options: Options<UpdatePrompt2Data, ThrowOnError>) => (options.client ?? client).post<UpdatePrompt2Responses, UpdatePrompt2Errors, ThrowOnError>({
    url: '/api/chat-tests/update-prompt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Prompt
 */
export const deletePrompt2 = <ThrowOnError extends boolean = false>(options: Options<DeletePrompt2Data, ThrowOnError>) => (options.client ?? client).post<DeletePrompt2Responses, DeletePrompt2Errors, ThrowOnError>({
    url: '/api/chat-tests/delete-prompt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Contexts
 */
export const listContexts = <ThrowOnError extends boolean = false>(options?: Options<ListContextsData, ThrowOnError>) => (options?.client ?? client).post<ListContextsResponses, ListContextsErrors, ThrowOnError>({ url: '/api/chat-tests/list-contexts', ...options });

/**
 * Get Context
 */
export const getContext = <ThrowOnError extends boolean = false>(options: Options<GetContextData, ThrowOnError>) => (options.client ?? client).post<GetContextResponses, GetContextErrors, ThrowOnError>({
    url: '/api/chat-tests/get-context',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Context
 */
export const createContext = <ThrowOnError extends boolean = false>(options: Options<CreateContextData, ThrowOnError>) => (options.client ?? client).post<CreateContextResponses, CreateContextErrors, ThrowOnError>({
    url: '/api/chat-tests/create-context',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Context
 */
export const deleteContext = <ThrowOnError extends boolean = false>(options: Options<DeleteContextData, ThrowOnError>) => (options.client ?? client).post<DeleteContextResponses, DeleteContextErrors, ThrowOnError>({
    url: '/api/chat-tests/delete-context',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Models
 */
export const listModels2 = <ThrowOnError extends boolean = false>(options?: Options<ListModels2Data, ThrowOnError>) => (options?.client ?? client).post<ListModels2Responses, ListModels2Errors, ThrowOnError>({ url: '/api/chat-tests/list-models', ...options });

/**
 * Create Model
 */
export const createModel2 = <ThrowOnError extends boolean = false>(options: Options<CreateModel2Data, ThrowOnError>) => (options.client ?? client).post<CreateModel2Responses, CreateModel2Errors, ThrowOnError>({
    url: '/api/chat-tests/create-model',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Model
 */
export const deleteModel2 = <ThrowOnError extends boolean = false>(options: Options<DeleteModel2Data, ThrowOnError>) => (options.client ?? client).post<DeleteModel2Responses, DeleteModel2Errors, ThrowOnError>({
    url: '/api/chat-tests/delete-model',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Tests
 */
export const listTests2 = <ThrowOnError extends boolean = false>(options?: Options<ListTests2Data, ThrowOnError>) => (options?.client ?? client).post<ListTests2Responses, ListTests2Errors, ThrowOnError>({ url: '/api/chat-tests/list-tests', ...options });

/**
 * Create Test
 */
export const createTest2 = <ThrowOnError extends boolean = false>(options: Options<CreateTest2Data, ThrowOnError>) => (options.client ?? client).post<CreateTest2Responses, CreateTest2Errors, ThrowOnError>({
    url: '/api/chat-tests/create-test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Test
 */
export const updateTest2 = <ThrowOnError extends boolean = false>(options: Options<UpdateTest2Data, ThrowOnError>) => (options.client ?? client).post<UpdateTest2Responses, UpdateTest2Errors, ThrowOnError>({
    url: '/api/chat-tests/update-test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Test
 */
export const deleteTest2 = <ThrowOnError extends boolean = false>(options: Options<DeleteTest2Data, ThrowOnError>) => (options.client ?? client).post<DeleteTest2Responses, DeleteTest2Errors, ThrowOnError>({
    url: '/api/chat-tests/delete-test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run Test
 */
export const runTest2 = <ThrowOnError extends boolean = false>(options: Options<RunTest2Data, ThrowOnError>) => (options.client ?? client).post<RunTest2Responses, RunTest2Errors, ThrowOnError>({
    url: '/api/chat-tests/run-test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fill Missing
 */
export const fillMissing2 = <ThrowOnError extends boolean = false>(options: Options<FillMissing2Data, ThrowOnError>) => (options.client ?? client).post<FillMissing2Responses, FillMissing2Errors, ThrowOnError>({
    url: '/api/chat-tests/fill-missing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fill Missing All
 */
export const fillMissingAll2 = <ThrowOnError extends boolean = false>(options?: Options<FillMissingAll2Data, ThrowOnError>) => (options?.client ?? client).post<FillMissingAll2Responses, FillMissingAll2Errors, ThrowOnError>({ url: '/api/chat-tests/fill-missing-all', ...options });

/**
 * Get Results
 */
export const getResults2 = <ThrowOnError extends boolean = false>(options: Options<GetResults2Data, ThrowOnError>) => (options.client ?? client).post<GetResults2Responses, GetResults2Errors, ThrowOnError>({
    url: '/api/chat-tests/get-results',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Progress
 */
export const progress2 = <ThrowOnError extends boolean = false>(options?: Options<Progress2Data, ThrowOnError>) => (options?.client ?? client).post<Progress2Responses, Progress2Errors, ThrowOnError>({ url: '/api/chat-tests/progress', ...options });

/**
 * List Outputs
 *
 * The generated turns, for inspecting what a competitor actually produced.
 */
export const listOutputs = <ThrowOnError extends boolean = false>(options?: Options<ListOutputsData, ThrowOnError>) => (options?.client ?? client).post<ListOutputsResponses, ListOutputsErrors, ThrowOnError>({ url: '/api/chat-tests/list-outputs', ...options });

/**
 * List Judges
 */
export const listJudges2 = <ThrowOnError extends boolean = false>(options?: Options<ListJudges2Data, ThrowOnError>) => (options?.client ?? client).post<ListJudges2Responses, ListJudges2Errors, ThrowOnError>({ url: '/api/chat-tests/list-judges', ...options });

/**
 * Next Pair
 */
export const nextPair2 = <ThrowOnError extends boolean = false>(options: Options<NextPair2Data, ThrowOnError>) => (options.client ?? client).post<NextPair2Responses, NextPair2Errors, ThrowOnError>({
    url: '/api/chat-tests/next-pair',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cast Vote
 */
export const castVote2 = <ThrowOnError extends boolean = false>(options: Options<CastVote2Data, ThrowOnError>) => (options.client ?? client).post<CastVote2Responses, CastVote2Errors, ThrowOnError>({
    url: '/api/chat-tests/cast-vote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear Votes
 */
export const clearVotes2 = <ThrowOnError extends boolean = false>(options: Options<ClearVotes2Data, ThrowOnError>) => (options.client ?? client).post<ClearVotes2Responses, ClearVotes2Errors, ThrowOnError>({
    url: '/api/chat-tests/clear-votes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit Contact
 */
export const submitContact = <ThrowOnError extends boolean = false>(options: Options<SubmitContactData, ThrowOnError>) => (options.client ?? client).post<SubmitContactResponses, SubmitContactErrors, ThrowOnError>({
    url: '/api/contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Serve Spa
 */
export const serveSpa = <ThrowOnError extends boolean = false>(options: Options<ServeSpaData, ThrowOnError>) => (options.client ?? client).get<ServeSpaResponses, ServeSpaErrors, ThrowOnError>({ url: '/{full_path}', ...options });
